/* Barre « Ajouter au panier » sticky — Maison Kireru.
   Le bouton d'origine reste dans le formulaire ; la barre sticky est un
   CLONE hissé directement dans <body> : position:fixed à l'intérieur de la
   carte produit (ancêtres overflow/transform) est clippée sur Safari iOS,
   un élément enfant de <body> ne l'est jamais. Syntaxe volontairement
   conservatrice (pas de méthodes privées) pour les anciens Safari. */
class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    var form = this.closest('[data-ref="product-form"]');
    var footer = document.querySelector('[data-ref="footer"]');
    var mainBtn = form ? form.querySelector('[data-ref="add-to-cart-button"]') : null;
    if (!form || !mainBtn) return;
    if (document.getElementById('mk-sticky-atc')) return;

    var bar = document.createElement('div');
    bar.id = 'mk-sticky-atc';
    bar.style.cssText =
      'position:fixed;left:0;right:0;bottom:0;z-index:2147483000;display:none;' +
      'background:#ffffff;border-top:1px solid rgba(27,25,20,.12);' +
      'padding:10px 20px calc(10px + env(safe-area-inset-bottom, 0px));box-sizing:border-box;';

    var btn = mainBtn.cloneNode(true);
    btn.type = 'button';
    btn.removeAttribute('name');
    btn.removeAttribute('data-ref');
    btn.removeAttribute('id');
    btn.style.cssText = 'display:block;width:100%;max-width:520px;margin:0 auto;';
    btn.style.setProperty('background-color', '#1b1914', 'important');
    btn.style.setProperty('color', '#ffffff', 'important');
    btn.style.setProperty('opacity', '1', 'important');
    btn.style.setProperty('text-align', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');

    /* Hors de son conteneur d'origine, le clone perd les règles à container
       queries qui n'affichent qu'UN des deux libellés : on garde le long. */
    function fixLabel() {
      var small = btn.querySelector('.small-add-to-cart-text');
      var full = btn.querySelector('.full-add-to-cart-text');
      if (small) small.style.display = 'none';
      if (full) {
        full.style.display = 'block';
        full.style.width = '100%';
        full.style.setProperty('text-align', 'center', 'important');
      }
    }
    fixLabel();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      mainBtn.click();
    });
    bar.appendChild(btn);
    document.body.appendChild(bar);

    function inViewport(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < vh;
    }

    var lastHtml = mainBtn.innerHTML;
    var shown = false;

    /* Tiroir panier (ou tout overlay qui bloque le scroll) ouvert : la barre
       doit disparaître, sinon elle recouvre le bouton « Commander ». */
    function overlayOpen() {
      var drawer = document.querySelector('cart-drawer.is-open');
      if (drawer) return true;
      return !!(document.body.classList && document.body.classList.contains('overflow-hidden'));
    }

    function tick() {
      var active = !inViewport(form) && !inViewport(footer) && !overlayOpen();
      if (active !== shown) {
        shown = active;
        bar.style.display = active ? 'block' : 'none';
        if (document.body.classList) {
          if (active) {
            document.body.classList.add('mk-sticky-on');
          } else {
            document.body.classList.remove('mk-sticky-on');
          }
        }
      }
      if (active) {
        if (mainBtn.innerHTML !== lastHtml) {
          lastHtml = mainBtn.innerHTML;
          btn.innerHTML = lastHtml;
          fixLabel();
        }
        if (btn.disabled !== mainBtn.disabled) {
          btn.disabled = mainBtn.disabled;
          btn.style.setProperty('opacity', btn.disabled ? '0.5' : '1', 'important');
        }
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
